import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import underscore from "vue-underscore";
import Vuetify from "vuetify";
import VueFirestore from "vue-firestore";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

Raven.config("https://4898e4d0088b473e8937ef248dbcf4c4@sentry.io/1250365", {
  release: "1.0",
  environment: process.env.NODE_ENV
})
  .addPlugin(RavenVue, Vue)
  .install();

Vue.use(Vuetify);
Vue.use(VueFirestore);
Vue.use(underscore);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
